import { SUPPORTED_LANGUAGES } from './locale.js';
export const DEFAULT_LANGUAGE_LABELS = {
    ru: 'Русский',
    en: 'Английский',
    uz: 'Узбекский (лат.)',
    tg: 'Таджикский',
    ky: 'Кыргызский',
    az: 'Азербайджанский',
    hy: 'Армянский',
    kk: 'Казахский',
    hi: 'Хинди',
    it: 'Итальянский',
    ro: 'Румынский',
};
export function getDefaultLanguageLabel(language) {
    const normalized = SUPPORTED_LANGUAGES.find((value) => value === language);
    return normalized ? DEFAULT_LANGUAGE_LABELS[normalized] : language.toUpperCase();
}
//# sourceMappingURL=languageLabels.js.map